

export function hasTouch() {
    return 'ontouchstart' in window;
}

export function queryParams() {
    const o = {} as { [key: string]: any };
    const queryParms = window.location.search
        .replace(/^\?/, '')
        .split('&');

    for (let i = 0; i < queryParms.length; i++) {
        const param = queryParms[i].split('=').map(decodeURIComponent);
        const key = param[0];
        const value = parseValue(param[1] || null);
        if (o[key]) {
            if (!o[key].push) {
                o[key] = [o[key]];
            }
            o[key].push(value);
        } else {
            o[key] = value;
        }
    }

    return o;

    function parseValue(value: string) {
        if (isNumeric(value)) {
            return parseFloat(value);
        }
        else if (typeof value === 'string') {
            let match = value.match(/(\d{4})-(\d\d?)-(\d\d?)/);
            if (match && match.length > 3) {
                return new Date(+match[1], +match[2] - 1, +match[3]);
            } else {
                match = value.match(/(\d\d?)[-.](\d\d?)[-.](\d{4})/);
                if (match && match.length > 3) {
                    return new Date(+match[3], +match[2] - 1, +match[1]);
                }
            }
        }

        return value;
    }
}

export function selectText(el: HTMLElement, win: Window = window) {
    const doc = win.document;
    if (win.getSelection && doc.createRange) {
        const sel = win.getSelection();
        const range = doc.createRange();
        range.selectNodeContents(el);
        sel.removeAllRanges();
        sel.addRange(range);
    }

    try {
        document.execCommand('copy');
    }
    catch (e) {
        // ignored
    }
}


export function isNumeric(value: string) {
    return !Number.isNaN(parseFloat(value)) && Number.isFinite(+value);
}


export function detectTouchDevices(callback: (isTouchDevice: boolean) => void) {
    window.addEventListener('touchstart', () => {
        callback(true);
    });
    $(window).on("resize", () => {
        // such small devices are most likely touch devices
        if (window.innerWidth < 1199) {
            callback(true);
        }
    });
}


export function ready(cb: () => void) {
    if (document.readyState !== 'loading') cb();
    else document.addEventListener('DOMContentLoaded', cb);
}


export function recaptcha(recaptcha: Element) {
    return new Promise((resolve, reject) => {
        try {
            if (!recaptcha) {
                // on second call..
                resolve(null);
                return;
            }

            const key = recaptcha.getAttribute("key");
            const action = recaptcha.getAttribute("action");

            if (key && action) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'recaptchaToken';
                recaptcha.parentElement.replaceChild(input, recaptcha);

                const src = document.createElement('script');
                const head = document.head || document.getElementsByTagName('head')[0];
                src.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
                src.async = false;
                src.onload = () => {
                    const scope = global as any as { grecaptcha: GRecaptcha };
                    scope.grecaptcha.ready(() => scope.grecaptcha.execute(key, { action: action }).then(token => {
                        input.value = token;
                        resolve(token);
                    }));
                };
                head.insertBefore(src, null);
            }
            else {
                resolve(null);
            }
        }
        catch (e) {
            reject(e);
        }
    });

    type GRecaptcha = {
        ready(cb: () => void): void,
        execute(key: string, config: { action: string }): Promise<string>,
    }
}
